import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment } from 'react';
import createStore from '../utils/createStore';
import getBlockId from '../../utils/getBlockId';
import Lightbox from './components/Lightbox';

function findLightboxItems(editor) {
  return editor.props.plugins.filter(function (plugin) {
    return plugin.lightboxItems;
  }).reduce(function (memo, plugin) {
    return memo.concat(plugin.lightboxItems.getItems(editor));
  }, []);
}

function findLightboxItemRenderer(editor, type) {
  return editor.props.plugins.filter(function (plugin) {
    return plugin.lightboxItems;
  }).find(function (plugin) {
    return plugin.lightboxItems.id === type;
  }).lightboxItems.renderItem;
}

function renderItem(editor, item) {
  var itemRenderer = findLightboxItemRenderer(editor, item.type);
  return itemRenderer(item);
}

export default function LightboxPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getUser = _ref.getUser,
      getUser = _ref$getUser === void 0 ? function () {
    return null;
  } : _ref$getUser;

  var defaultState = {
    show: false,
    index: 0,
    medias: []
  };
  var store = createStore({
    state: defaultState
  });
  return [{
    commands: {
      openLightbox: function openLightbox(editor, node) {
        var medias = findLightboxItems(editor);
        var mediaIds = medias.map(function (media) {
          return media.id;
        });
        var index = mediaIds.indexOf(getBlockId(node));
        store.updateItem('state', _objectSpread({}, defaultState, {
          show: true,
          medias: medias,
          index: index >= 0 ? index : 0
        }));
      },
      closeLightbox: function closeLightbox() {
        store.updateItem('state', _objectSpread({}, defaultState, {
          show: false
        }));
      },
      goLightboxNext: function goLightboxNext() {
        var state = store.getItem('state');
        store.updateItem('state', _objectSpread({}, state, {
          index: state.index === state.medias.length - 1 ? 0 : state.index + 1
        }));
      },
      goLightboxPrevious: function goLightboxPrevious() {
        var state = store.getItem('state');
        store.updateItem('state', _objectSpread({}, state, {
          index: state.index === 0 ? state.medias.length - 1 : state.index - 1
        }));
      }
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Fragment, null, next(), React.createElement(Lightbox, {
        getUser: getUser,
        pluginStore: store,
        editor: editor,
        renderItem: renderItem
      }));
    }
  }];
}